export const experiencesAPIUrls = {
  getTickets: '/tickets',
  createTicket: '/tickets',
  updateTicket: '/tickets/{id}',
  deleteTicket: '/tickets/{id}',
  getTransactions: '/transactions',
  createTransaction: '/transactions',
  updateTransaction: '/transactions/{id}',
  deleteTransaction: '/transactions/{id}',
  getExperiences: '/experiences/fetch-all',
} as const;
